import { createFileRoute, redirect } from "@tanstack/react-router";
import AppCard from "@/components/AppCard.tsx";
import { HrdFormulairesDataGrid } from "@components/hrd/formulaires/HrdFormulairesDataGrid.tsx";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN, ROLE_USER } from "@/constants";
import { getHasHrdAccess } from "@/auth/hasHrdAccess.tsx";

export const Route = createFileRoute("/_dashboard/hrd/formulaires/")({
  beforeLoad: (args) => {
    const { context } = args;
    requireRole([ROLE_ADMIN, ROLE_USER])(args);
    const hasHrdAccess = getHasHrdAccess(
      context.session!.user!.hrdAccessStatus
    );

    // Check HRD access for non-admins only
    if (!context.session?.user?.isAdmin && !hasHrdAccess) {
      throw redirect({
        to: "/unauthorized",
        search: {
          redirect: location.href,
        },
      });
    }

    return { session: context.session! };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AppCard title="HRD Collect - Formulaires">
      <HrdFormulairesDataGrid />
    </AppCard>
  );
}
